import { logger } from './logger';

type EventCallback = (timeLeftInSeconds: number) => void;
type EventType = 'set';
type Listener = { type: EventType; listenerId: string; cb: EventCallback };

export const jwtSessionLogger = {
  key: 'jwt-session-end',
  sessionTimeInMilliseconds: 15 * 60 * 1000,
  formatter: new Intl.RelativeTimeFormat('en', {
    style: 'long',
    localeMatcher: 'best fit', // other values: "lookup"
    numeric: 'always'
  }),
  listeners: [] as Listener[],
  set: () => {
    sessionStorage.setItem(jwtSessionLogger.key, (Date.now() + jwtSessionLogger.sessionTimeInMilliseconds).toString());
    jwtSessionLogger._executeListeners('set', jwtSessionLogger.howMuchTimeLeftInSeconds());
  },
  howMuchTimeLeftInSeconds: (): number => {
    return milliToSeconds(jwtSessionLogger.getEndTimeOfSession() - Date.now());
  },
  getEndTimeOfSession: (): number => {
    if (!sessionStorage.getItem(jwtSessionLogger.key)) {
      logger.warn('JWT session does not exist');
    }
    return parseFloat(sessionStorage.getItem(jwtSessionLogger.key) ?? '0');
  },
  clear: () => {
    sessionStorage.removeItem(jwtSessionLogger.key);
  },
  addListener: (type: EventType, listenerId: string, cb: EventCallback) => {
    jwtSessionLogger.listeners.push({
      type,
      listenerId,
      cb
    });
  },
  removeListener: (type: EventType, listenerId: string) => {
    jwtSessionLogger.listeners = jwtSessionLogger.listeners.filter((listener) => {
      return listener.listenerId !== listenerId || listener.type !== type;
    });
  },
  _executeListeners(type: EventType, value: number) {
    jwtSessionLogger.listeners.forEach((listener) => {
      if (listener.type === type) {
        listener.cb(value);
      }
    });
  }
};

function milliToSeconds(milliseconds: number): number {
  return Math.floor(milliseconds / 1000);
}
